import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryItemStatusReport } from './Pages/listing';

export const FactoryItemStatusReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryItemStatusReport} />
    </Fragment>
)